import { render } from "./DescriptorForm.vue?vue&type=template&id=5a9c8c2c"
import script from "./DescriptorForm.vue?vue&type=script&lang=js"
export * from "./DescriptorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__